import { Col, Container, Image, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import bgHome from '../img/bgHome.png'

function DashboardCalidad({t}){
    return (
        <Container fluid>
            <Row>
                <Col xs="12" md="6" className="px-0" >                    
                    <div className="position-relative">
                        <div className="bg-info-1">
                            <div className="p-5">
                                <h3 className="text-white">{t('operador_dashboard_title')}</h3>
                                <p className="text-white my-4">{t('operador_dashboard_title1')}
                                </p>
                            </div>
                        </div>                        
                    </div>                    
                </Col>
                <Col xs="12" md="6" className="d-md-block d-none px-0">
                    <Image src={bgHome} fluid />
                </Col>
            </Row>
        </Container>
    )
}

export default withTranslation()(DashboardCalidad)